import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function usePortfolioSnapshots() {
  const [snapshots, setSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get("/portfolio/snapshots");
      setSnapshots(res.data?.snapshots || res.data || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  const createSnapshot = useCallback(async () => {
    try {
      await api.post("/portfolio/snapshots");
      toast.success("Snapshot captured");
      await refetch();
      return true;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to capture snapshot");
      return false;
    }
  }, [refetch]);

  return { snapshots, loading, error, refetch, createSnapshot };
}
